export default __webpack_public_path__ + "static/hp-brand-deck-25-9835aa98c3ee397ecfe3a2cfa1234249.png";